module.exports = __webpack_public_path__ + "img/N55.426272d6.jpg";